export const fromPlaceholder = lang => `Your beautiful ${lang} goes here`;
export const toPlaceholder = `And the translation goes here`;
export const geordie = `Geordie`;



// WEBPACK FOOTER //
// ./src/copy/index.js